import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate, resolvePath, useLocation } from "react-router-dom";
import axios from "axios";
import { Spinner } from "reactstrap";





const TurnosVacunacion = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [turnoUrl, setTurnoUrl] = useState("");   

    useEffect(() => {
        //const hashLogin = "25824F3E492DFB58EADD24A68B611113E784992014A014307511DF247C0C137C";
        const hashLogin = localStorage.getItem("hashLogin")
        
        axios.get("https://api.ciudadanos360.com/login/GetDatosCiudadano/"+hashLogin)
        .then((resp)=>{
            console.log(resp);
            var dataR = {
                CiudadanosId : resp.data.Id,
                Turnero: "salud",
                TipoTurno: location.state.name,
            };
            
            console.log(dataR)
            axios.post("https://api.ciudadanos360.com/Turnos/AConsultaTurno",dataR)   //TODO: Errors
            .then((resp1)=> {
               setIsLoading(false);
                setTurnoUrl( "https://trn.municipiopilar.app/?agendaid="+location.state.id+"&branchid=393&turnero=licencias&nombre="+resp.data.Nombre+"&apellido="+
                 resp.data.Apellido+"&dni="+resp.data.DNI+"&celular="+resp.data.Celular+"&email="+resp.data.Email+"&idturno="+resp1.data.Id
                );
               ;}
            ).catch((err1) => {
                console.log(err1);
                return(<h1>Error segundo llamado</h1>);
            });
        })
        .catch((err0) => {
            console.log(err0);
            return(<h1>Error primer llamado</h1>);
        });
        
    },[]);

    
   return ( <>{isLoading ?  (<div className="col-12" visible>
   <Spinner color="red"/>
   
</div>): <div class="container text-center mainContent" >
<img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnosvacunacionmenu")}}/>
                <iframe src={turnoUrl} frameborder="0" width="100%" height="70%"></iframe>
             </div>}

</>)
   

}

export default TurnosVacunacion;